var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "dropdown" } }, [
    _c("div", { staticClass: "dropdown-filter" }, [
      _vm.hasSelection
        ? _c("div", { staticClass: "row no-gutters" }, [
            _vm.filter.prezzo
              ? _c(
                  "div",
                  {
                    staticClass: "alink mr-1",
                    on: {
                      click: function($event) {
                        return _vm.onRemove("prezzo")
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "mr-2" }, [_vm._v("PREZZO")]),
                    _vm._v(" "),
                    _c("b", { staticClass: "mr-1" }, [
                      _vm._v("€ " + _vm._s(_vm.minPriceF))
                    ]),
                    _vm._v("-\n                "),
                    _c("b", [_vm._v("€ " + _vm._s(_vm.maxPriceF))])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.filter.nome
              ? _c(
                  "div",
                  {
                    staticClass: "alink",
                    on: {
                      click: function($event) {
                        return _vm.onRemove("nome")
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "mr-2" }, [_vm._v("NOME")]),
                    _c("b", [_vm._v(_vm._s(_vm.filter.nome))])
                  ]
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "bg-white" }, [
        _c(
          "form",
          {
            on: {
              submit: function($event) {
                $event.preventDefault()
              }
            }
          },
          [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Prezzo")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row no-gutters pl-2 pl-md-5 py-3 bg-light" },
                [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("PriceRangeSlider", {
                        ref: "priceRangeSlider",
                        attrs: {
                          "min-price": _vm.minPrice,
                          "max-price": _vm.maxPrice,
                          value: _vm.filter.prezzo
                        },
                        on: { input: _vm.onInputPrezzo }
                      })
                    ],
                    1
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Nome")]),
              _vm._v(" "),
              _c("div", { staticClass: "row no-gutters p-3 bg-light" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("input", {
                    staticClass: "form-control",
                    attrs: { type: "text", name: "nome" },
                    domProps: { value: _vm.filter.nome },
                    on: { input: _vm.onInputNome }
                  })
                ])
              ])
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c808cc2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c808cc2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/pages/tour-accompagnati/dropdown/DropdownFilterTour.vue
// module id = null
// module chunks = 